/**
 * Module dependencies.
 */

import * as featureTypes from './feature-types'
import splitio from '@splitsoftware/splitio'
import pTimeout from '../p-timeout'
import * as errors from 'lib/utils/errors'

/**
 * Singleton "split" instance.
 */

let splitClient = null
let workspaceId = null

/**
 * Exports.
 */

export { boot, showFeature, featureTypes }

/**
 * Bootstrap split.io.  Will gracefully fail if split.io
 * is down by immediately calling back `fn`.
 *
 * @param {Object} opts { key, workspaceId }
 * @return {Promise}
 * @api public
 */
function boot (opts) {
  workspaceId = opts.workspaceId
  // bootstrap split.io
  // authorizationKey defaults to '' to unbreak regression tests
  const splitFactory = splitio({
    core: {
      key: opts.workspaceId,
      authorizationKey: opts.key || ''
    },
    storage: {
      type: 'LOCALSTORAGE'
    }
  })
  splitClient = splitFactory.client()

  // wait for split to be "ready" but continue booting if split takes too long or errors
  return pTimeout(
    splitClient.ready(),
    1000,
    new Error('Split timed out after 1000 milliseconds')
  ).catch(err => errors.track(err))
}

/**
 * Check if we should show a feature (by its `featureId`).
 * Handles split.io downtime by gracefully returning
 * `false`.
 *
 * @param {String} featureId
 * @return {Boolean}
 * @api public
 */

function showFeature (featureId) {
  // if split.io is down, ALWAYS return false
  if (!splitClient) {
    return false
  }

  // if the feature is "on" in split, return `true`.  in
  // all other cases, return `false`.  this means if
  // split's servers are down, we will NOT display new
  // features
  const shouldShow = splitClient.getTreatment(featureId) === 'on'
  if (shouldShow) {
    // record all experiments viewed by the user
    window.analytics.track('Experiment Viewed', {
      feature_id: featureId,
      source: 'split',
      workspace_id: workspaceId
    })
  }
  return shouldShow
}



// WEBPACK FOOTER //
// ./lib/feature/index.js